export function agePlusGenerator(age = 18) {
  const date = new Date();
  date.setFullYear(date.getFullYear() - age);
  return date;
}

export function remainingMinSecs(remaining) {
  let minutes = 0;
  let seconds = 0;

  if (remaining >= 0) {
    minutes = Math.floor(remaining / 60000);
    seconds = ((remaining % 60000) / 1000).toFixed(0);

    if (minutes < 10) {
      minutes = `0${minutes}`;
    }

    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
  }

  return {
    minutes,
    seconds,
  };
}
